import { AdType } from 'core/rtbCampaign/RtbCampaign';

export const defaultCampaignBidPrice: {
  type: string;
  autoBidCap: { [key: string]: string };
  bidFloor: { [key: string]: string };
}[] = [
  {
    type: AdType.DISPLAY,
    autoBidCap: {
      cpc: '300',
      cpm: '500',
    },
    bidFloor: {
      cpc: '100',
      cpm: '100',
    },
  },
  {
    type: AdType.KEYWORD,
    autoBidCap: {
      cpc: '100',
      cpm: '25',
    },
    bidFloor: {
      cpc: '5',
      cpm: '5',
    },
  },
  {
    type: AdType.SMART_KEYWORD,
    autoBidCap: {
      cpc: '100',
      cpm: '25',
    },
    bidFloor: {
      cpc: '5',
      cpm: '5',
    },
  },
  {
    type: AdType.MAX_CVR_KEYWORD,
    autoBidCap: {
      cpc: '100',
      cpm: '25',
    },
    bidFloor: {
      cpc: '5',
      cpm: '5',
    },
  },
  {
    type: AdType.SHOP,
    autoBidCap: {
      cpc: '100',
      cpm: '25',
    },
    bidFloor: {
      cpc: '10',
      cpm: '10',
    },
  },
  {
    type: AdType.RECOMMEND,
    autoBidCap: {
      cpc: '100',
      cpm: '25',
    },
    bidFloor: {
      cpc: '3',
      cpm: '3',
    },
  },
  {
    type: AdType.OUTBOUND_KEYWORD,
    autoBidCap: {
      cpc: '100',
      cpm: '25',
    },
    bidFloor: {
      cpc: '0',
      cpm: '0',
    },
  },
];
